import { externalRoutes, routes } from '~constants/routes';
import { annals } from '~features/annals/hooks';

export const useNavigationLinksAnalytics = (sideMenu: boolean) => {
	const annalsNavAboutClicked = annals.navigation.useNavAboutClicked();

	const annalsNavTopGridClicked =
		annals.navigation.useNavTopGridButtonClicked();
	const annalsNavSideGridClicked =
		annals.navigation.useNavLeftGridButtonClicked();

	const annalsNavTopChatsClicked =
		annals.navigation.useNavTopChatsButtonClicked();
	const annalsNavSideChatsClicked =
		annals.navigation.useNavLeftChatsButtonClicked();

	const annalsNavTopCreateCharacterClicked =
		annals.navigation.useNavTopCreateCharacterButtonClicked();
	const annalsNavSideCreateCharacterClicked =
		annals.navigation.useNavLeftCreateCharacterButtonClicked();

	const annalsNavTopCreateImageClicked =
		annals.navigation.useNavTopCreateImageButtonClicked();
	const annalsNavSideCreateImageClicked =
		annals.navigation.useNavLeftCreateImageButtonClicked();

	const annalsNavTopCreateVideoClicked =
		annals.navigation.useNavTopCreateVideoButtonClicked();
	const annalsNavSideCreateVideoClicked =
		annals.navigation.useNavLeftCreateVideoButtonClicked();

	const annalsNavSideAffiliateClicked =
		annals.navigation.useNavLeftAffiliateButtonClicked();
	const annalsNavSidePartnershipClicked =
		annals.navigation.useNavLeftPartnershipButtonClicked();

	const annalsNavigationClick = (path: string) => {
		switch (path) {
			case routes.explore.home:
				return sideMenu ? annalsNavSideGridClicked : annalsNavTopGridClicked;
			case routes.chats.home:
				return sideMenu ? annalsNavSideChatsClicked : annalsNavTopChatsClicked;
			case routes.company.about:
				return annalsNavAboutClicked;
			case routes.generate.images:
				return sideMenu
					? annalsNavSideCreateImageClicked
					: annalsNavTopCreateImageClicked;
			case routes.generate.videos:
				return sideMenu
					? annalsNavSideCreateVideoClicked
					: annalsNavTopCreateVideoClicked;
			case routes.generate.character:
				return sideMenu
					? annalsNavSideCreateCharacterClicked
					: annalsNavTopCreateCharacterClicked;

			case externalRoutes.becomeAffiliate:
				return sideMenu ? annalsNavSideAffiliateClicked : () => undefined;
			case externalRoutes.creatorUrl:
				return sideMenu ? annalsNavSidePartnershipClicked : () => undefined;
			default:
				return () => undefined;
		}
	};

	return { annalsNavigationClick };
};
